







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Client} from '@/models';

import CrudClientEditLight from '@/components/Crud/Client/EditLight.vue';

@Component({
	components: {
		CrudClientEditLight,
	}
})
export default class CrudClientEditDialogLight extends Vue {
	@InOut({ type: Client  , isVModel: true }) private value!: Client;

	@Emit()
	private onSubmit(client: Client) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
